import { FC } from 'react';

type CookiesViewProps = {
  title: string;
  description: string[];
  acceptButtonText: string;
  declineButtonText: string;
  onClickAccept: () => void;
  onClickDecline: () => void;
};

export const CookiesView: FC<CookiesViewProps> = ({
  title,
  description,
  acceptButtonText,
  declineButtonText,
  onClickAccept,
  onClickDecline,
}) => (
  <div className="bg-checkout-card-gradient fixed left-0 top-0 z-[10000] flex w-full items-center justify-center backdrop-blur-md">
    <div className="relative w-full p-6 shadow-2xl">
      <div className="mb-6 text-center">
        <h3 className="font-poppins mb-4 text-[22.5px] font-bold text-[#ECEAED]">
          {title}
        </h3>
      </div>
      <div className="font-objektiv-mk3 mb-8 text-[12.5px] md:text-[15px]">
        {description.map((paragraph) => (
          <p
            key={paragraph}
            className="font-poppins text-center leading-relaxed text-[#ECEAED]"
          >
            {paragraph}
          </p>
        ))}
      </div>
      <div className="flex flex-row justify-center gap-3 sm:gap-4">
        <button
          type="button"
          id="btn-accept-all"
          onClick={onClickAccept}
          className="font-objektiv-mk3 max-w-[275px] flex-1 rounded-lg bg-[#8233CC] px-4 py-2 text-[12.5px] font-bold text-[#ECEAED] transition-colors duration-200 hover:bg-[#7C3AED] md:text-[17.5px]"
        >
          {acceptButtonText}
        </button>
        <button
          type="button"
          id="btn-decline-all"
          onClick={onClickDecline}
          className="font-objektiv-mk3 max-w-[275px] flex-1 rounded-lg bg-[#8233CC] px-4 py-2 text-[12.5px] font-bold text-[#ECEAED] transition-colors duration-200 hover:bg-[#7C3AED] md:text-[17.5px]"
        >
          {declineButtonText}
        </button>
      </div>
    </div>
  </div>
);
